import { Logo } from '../components/Logo'
import { Aco } from '../components/Aco';
import {
  PageContainer,
  HeroSection,
  HeroContent,
  BackLink,
  ContentSection,
  Container,
  MainContent,
  SideContent,
  ProductTitle,
  ProductSubtitle,
  SectionTitle,
  SubSectionTitle,
  Paragraph,
  InfoTable,
  TableRow,
  TableDataLabel,
  TableData,
  NumberData,
  List,
  AcoContainer,
  DecorativeElement
} from './ProductStyles';

const data = [
  {en: "1,8-cineole", ja: "1,8-シネオール", rebge: "Max:6", value: "5.53%"},
  {en: "Limonene", ja: "リモネン", rebge: "Max:6", value: "3.31%"},
  {en: "Linalool", ja: "リナロール", rebge: "20-45", value: "23.4%"},
  {en: "Camphor", ja: "カンフォール", rebge: "Max1.4", value: "0.88%"},
  {en: "Terpinen-4-ol", ja: "テルピネン-4-オール", rebge: "0.1-6.0", value: "0.29%"},
  {en: "Alpha-terpineol", ja: "アルファ-テルピネオール", rebge: "Trace to 7", value: "3.37%"},
  {en: "Linalyl acetate", ja: "リナリルアセテート", rebge: "25-46", value: "43.31%"},
]

export const Lavandula8 = () => (
  <PageContainer>
    <HeroSection>
      <BackLink to="/">ホームに戻る</BackLink>
      <HeroContent>
        <Logo />
      </HeroContent>
    </HeroSection>
    
    <ContentSection>
      <Container>
        <MainContent>
          <DecorativeElement className="top-right" />
          <DecorativeElement className="bottom-left" />
          
          <ProductTitle>フランス産 ラベンダー</ProductTitle>
          <ProductSubtitle>Lavandula angustifolia</ProductSubtitle>
          
          <SectionTitle>使用期限</SectionTitle>
          <Paragraph>{new Date(new Date('2027-07-01T00:00:00.000+09:00').getTime() - 1).toLocaleDateString()}</Paragraph>
          
          <SectionTitle>製品の特徴</SectionTitle>
          <InfoTable>
            <tbody>
              <TableRow>
                <TableDataLabel>原産国</TableDataLabel>
                <TableData>フランス</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出部位</TableDataLabel>
                <TableData>花/葉</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出方法</TableDataLabel>
                <TableData>水蒸気蒸留法</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>学名</TableDataLabel>
                <TableData>Lavandula angustifolia</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>科名</TableDataLabel>
                <TableData>シソ科</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>効果</TableDataLabel>
                <TableData>安眠、免疫力強化、肩こり、ニキビ、肌のアンチエイジング、虫除け</TableData>
              </TableRow>
            </tbody>
          </InfoTable>
          
          <SectionTitle>分析証明書</SectionTitle>
          
          <SubSectionTitle>製品識別と組成</SubSectionTitle>
          <List>
            <li>製品名: Lavender True</li>
            <li>学名: Lavandula angustifolia</li>
          </List>
          
          <SubSectionTitle>物理的および化学的特性</SubSectionTitle>
          <List>
            <li>外観: 透明、淡黄色から黄色の液体</li>
            <li>香り: 特徴的</li>
            <li>比重: 0.8750 から 0.8950 @ 20°C</li>
            <li>屈折率: 1.4550 から 1.4700 @ 20°C</li>
          </List>
          
          <SubSectionTitle>ガスクロマトグラフ分析結果</SubSectionTitle>
          <InfoTable>
            <tbody>
              {data.map((item, index) => (
                <TableRow key={index}>
                  <TableDataLabel>{item.ja}</TableDataLabel>
                  <NumberData>{item.value}</NumberData>
                </TableRow>
              ))}
            </tbody>
          </InfoTable>
        </MainContent>
        
        <SideContent>
          <AcoContainer>
            <Aco />
          </AcoContainer>
        </SideContent>
      </Container>
    </ContentSection>
  </PageContainer>
);